<ng-template #loader>
  <div class="mat-elevation-z1 shimmer-container">
    @for (_ of [].constructor(16); track $index) {
      <div class="stencil-shimmer shimmer"></div>
    }
  </div>
</ng-template>
<div>
  @if (meetings$ | async; as meetings) {
    <div class="page-container">
      @if (showTeamMemberFilter$ | async) {
        <mat-button-toggle-group
          class="calendar-tab-toggle-group"
          (change)="changedMeetingListTab($event.value)"
          [value]="'upcoming'"
        >
          <mat-button-toggle class="calendar-tab-toggle" value="upcoming">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.UPCOMING' | translate }}
          </mat-button-toggle>
          <mat-button-toggle class="calendar-tab-toggle" value="past">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.PAST' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        @if (filtersReady$ | async) {
          <div class="meeting-list-filters--new">
            <button mat-stroked-button class="calendar-user-filter" (click)="openTeamMemberFilter()">
              <span class="user-filter-content">
                <mat-icon>filter_list</mat-icon>
                <span class="user-filter-label">{{ selectedUserLabel$ | async }}</span>
              </span>
            </button>
            @if (selectedTab === 'past') {
              <forms-time-range-selector
                class="calendar-time-filter"
                [timeRangeOption]="timeRangeKeySelected"
                [timeRangeOptions]="timeRangeOptions"
                [max]="now"
                [useGalaxyFields]="true"
                (dateRangeChange)="setDateRange($event)"
                (timeRangeChange)="setTimeRangeKey($event)"
              ></forms-time-range-selector>
            }
          </div>
        }
      } @else {
        <div class="meeting-list-filters">
          <meeting-scheduler-meeting-filter
            class="calendar-meeting-filter"
            [meetingTypes]="allMeetingTypes$ | async"
            [selectedFilter]="selectedEventTypeFilter"
            (meetingTypeIdsSelected)="filterByMeetingTypeIds($event)"
          ></meeting-scheduler-meeting-filter>
          @if (selectedTab === 'past') {
            <forms-time-range-selector
              class="calendar-time-filter"
              [timeRangeOption]="timeRangeKeySelected"
              [timeRangeOptions]="timeRangeOptions"
              [max]="now"
              [useGalaxyFields]="true"
              (dateRangeChange)="setDateRange($event)"
              (timeRangeChange)="setTimeRangeKey($event)"
            ></forms-time-range-selector>
          }
          <div class="meeting-list-toggle-wrapper">
            <mat-button-toggle-group
              class="calendar-tab-toggle-group"
              (change)="changedMeetingListTab($event.value)"
              [value]="'upcoming'"
            >
              <mat-button-toggle class="calendar-tab-toggle" value="upcoming">
                {{ 'MEETING_SCHEDULER.MEETING_LIST.UPCOMING' | translate }}
              </mat-button-toggle>
              <mat-button-toggle class="calendar-tab-toggle" value="past">
                {{ 'MEETING_SCHEDULER.MEETING_LIST.PAST' | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="margin-top-component"></div>
      }
      @if (hideLoader$ | async) {
        @if ((meetings$ | async)?.length) {
          <div class="pad-style scrollable-container" (scroll)="onScroll($event)">
            <mat-accordion>
              @for (meeting of dataSource$ | async; track trackByMeetingId($index, meeting); let i = $index) {
                @if (!isSameDate(meeting?.date.start | date: 'EEEE, MMM d, y', i)) {
                  <div class="date">
                    {{ meeting?.date.start | date: ' MMM d, y' }}
                  </div>
                }

                <mat-expansion-panel class="expansion-panel" data-action="expanded-meeting-card">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="expansion-panel-title">
                      <div class="flex-class">
                        <div class="margin-right-10">
                          @if (meeting?.location === '' && meeting?.joinMeeting !== '') {
                            <mat-icon class="expansion-panel-header-icon">event </mat-icon>
                          }
                          @if (meeting?.location !== '' && meeting?.joinMeeting === '') {
                            <mat-icon class="expansion-panel-header-icon"> location_on </mat-icon>
                          }
                          @if (meeting?.location !== '' && meeting?.joinMeeting !== '') {
                            <mat-icon class="expansion-panel-header-icon"> business </mat-icon>
                          }
                        </div>
                        <div>
                          <div class="title-text">
                            {{ meeting.date.start | date: 'shortTime' }} - {{ meeting?.date.end | date: 'shortTime' }}
                          </div>
                          <span class="subtitle-text">
                            {{ meeting.topic || '—' }}
                          </span>
                        </div>
                      </div>
                      <div (click)="stopPropagation($event)">
                        @if (selectedTab === 'upcoming') {
                          <div class="expansion-panel-header-button-group">
                            @if (meeting?.joinMeeting) {
                              <button
                                mat-flat-button
                                color="primary"
                                class="expansion-panel-header-button-width margin-right-10"
                                (click)="openMeetingLink(meeting?.joinMeeting)"
                                data-action="clicked-join-meeting-button"
                              >
                                <mat-icon class="join-button-icon">video_call</mat-icon>
                                {{ 'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.JOIN' | translate }}
                              </button>
                            }
                            <button
                              mat-stroked-button
                              class="expansion-panel-header-button-width"
                              [matMenuTriggerFor]="modifyMeeting"
                              data-action="clicked-edit-meeting-button"
                            >
                              <mat-icon class="edit-button-icon">edit</mat-icon>
                              {{ 'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.EDIT' | translate }}
                            </button>
                            <mat-menu #modifyMeeting="matMenu" class="modify-meeting-menu">
                              <button mat-menu-item>
                                <meeting-scheduler-reschedule-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                  (meetingRescheduled)="onMeetingRescheduled($event)"
                                ></meeting-scheduler-reschedule-meeting-button>
                              </button>
                              <button mat-menu-item>
                                <meeting-scheduler-cancel-meeting-button
                                  [meeting]="meeting"
                                  [isMatItem]="true"
                                  [displayText]="'MEETING_SCHEDULER.CALENDER_VIEW.MEETING_LIST.CANCEL' | translate"
                                  (meetingCancelled)="onMeetingCancelled(meeting)"
                                ></meeting-scheduler-cancel-meeting-button>
                              </button>
                            </mat-menu>
                          </div>
                        }
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @if (!meeting.isSessionEventType) {
                    <ng-container
                      [ngTemplateOutlet]="standardMeetingLayout"
                      [ngTemplateOutletContext]="{ $implicit: meeting }"
                    >
                    </ng-container>
                  } @else {
                    <ng-container
                      [ngTemplateOutlet]="sessionEventMeetingLayout"
                      [ngTemplateOutletContext]="{ $implicit: meeting }"
                    ></ng-container>
                  }
                </mat-expansion-panel>
              }
            </mat-accordion>

            @if (isLoadingMore) {
              <div class="inline-loader-container">
                <glxy-loading-spinner size="medium"></glxy-loading-spinner>
              </div>
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="nomeetings"></ng-container>
        }
      } @else {
        <ng-container *ngTemplateOutlet="loadingPage"></ng-container>
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="loader"></ng-container>
  }

  <ng-template #nomeetings>
    <glxy-empty-state>
      <glxy-empty-state-hero>
        <img
          src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035080760057.prod/assets/booking_empty_state.png"
          alt="No meetings scheduled"
        />
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{
          (selectedTab === 'past'
            ? 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.PAST_TITLE'
            : 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.UPCOMING_TITLE_V2'
          ) | translate
        }}
      </glxy-empty-state-title>
      <p>
        {{
          (selectedTab === 'past'
            ? 'MEETING_SCHEDULER.MEETING_LIST.EMPTY_STATE.PAST_DESCRIPTION'
            : 'MEETING_SCHEDULER.MEETING_LIST.FILTER_NO_RESULTS_V2'
          ) | translate
        }}
      </p>
    </glxy-empty-state>
  </ng-template>
  <ng-template #loadingPage>
    <glxy-loading-spinner size="large" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
  </ng-template>

  <!-- Standard Meeting Layout Template -->
  <ng-template #standardMeetingLayout let-meeting>
    <div class="meeting-details-grid">
      <div class="grid-item">
        <div class="meeting-subtitle">{{ 'MEETING_SCHEDULER.MEETING_LIST.CONTACT_LABEL' | translate }}</div>
        <div class="comment">
          @if (meeting?.primaryContact?.contactId) {
            <a class="meeting-link" (click)="navigateToContact(meeting.primaryContact.contactId)">
              {{ meeting.primaryContact.name || '—' }}
            </a>
          } @else {
            {{ meeting?.primaryContact?.name || '—' }}
          }
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">{{ 'MEETING_SCHEDULER.MEETING_LIST.EMAIL_LABEL' | translate }}</div>
        <div class="comment">{{ meeting?.attendeeEmails || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.PHONE_LABEL' | translate }}
        </div>
        <div class="comment">
          {{ meeting?.contact?.phoneNumber || '—' }}
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.LOCATION_LABEL' | translate }}
        </div>
        <div class="comment">
          <div>{{ meeting?.location || '—' }}</div>
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_LINK' | translate }}
        </div>
        <div class="comment">
          @if (meeting?.joinMeeting) {
            <a class="meeting-link" [matTooltip]="meeting?.joinMeeting" (click)="openMeetingLink(meeting?.joinMeeting)">
              {{
                meeting?.joinMeeting?.length > 40
                  ? meeting?.joinMeeting?.substring(0, 40) + '...'
                  : meeting?.joinMeeting
              }}
            </a>
          } @else {
            —
          }
        </div>
      </div>
      @if (meeting?.hostNames.length > 0) {
        <div class="grid-item">
          <div class="meeting-subtitle">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.HOSTS_LABEL' | translate }}
          </div>
          <div class="comment">{{ meeting?.hostNames.join(', ') || '—' }}.</div>
        </div>
      }
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.COMMENTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.comments || '—' }}</div>
      </div>
      @if (meeting?.formAnswers.length > 0) {
        <div class="grid-item form-answers-section">
          <div class="meeting-subtitle">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.CUSTOM_QUESTION_LABEL' | translate }}
          </div>
          <div class="form-answers-grid">
            @for (answer of meeting?.formAnswers; track answer) {
              <div class="form-answer-item">
                <div class="meeting-subtitle">{{ answer.label }}</div>
                <div class="comment">{{ answer.answer.join(', ') }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>

  <!-- Session Event Layout Template -->
  <ng-template #sessionEventMeetingLayout let-meeting>
    <div class="meeting-details-grid">
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.HOSTS_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.hostNames?.join(', ') || '—' }}</div>
      </div>

      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.BOOKING_PAGE_LINK' | translate }}
        </div>
        <div class="comment">
          @if (meeting?.sessionRegistrationUrl) {
            <a
              class="meeting-link"
              [href]="meeting?.sessionRegistrationUrl"
              [matTooltip]="meeting?.sessionRegistrationUrl"
              target="_blank"
              (click)="stopPropagation($event)"
            >
              {{ meeting?.sessionRegistrationUrl }}
            </a>
          } @else {
            —
          }
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.LOCATION_LABEL' | translate }}
        </div>
        <div class="comment">{{ meeting?.location || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.MEETING_LINK' | translate }}
        </div>
        <div class="comment">
          @if (meeting?.joinMeeting) {
            <a class="meeting-link" [matTooltip]="meeting?.joinMeeting" (click)="openMeetingLink(meeting?.joinMeeting)">
              {{ meeting?.joinMeeting }}
            </a>
          } @else {
            —
          }
        </div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.REGISTRATION_CUTOFF_TIME' | translate }}
        </div>
        <div class="comment">{{ meeting?.registrationCutoff || '—' }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TOTAL_REGISTRATIONS' | translate }}
        </div>
        <div class="comment">
          <a class="meeting-link" (click)="openAttendeeListDialog(meeting)">
            {{ 'MEETING_SCHEDULER.MEETING_LIST.MANAGE' | translate }}
          </a>
        </div>
        <div class="comment">{{ meeting?.registeredAttendeeCount || 0 }} / {{ meeting?.maxAttendeeCount || 0 }}</div>
      </div>
      <div class="grid-item">
        <div class="meeting-subtitle">
          {{ 'MEETING_SCHEDULER.MEETING_LIST.ADD_TO_MY_WEBSITE' | translate }}
        </div>
        <div class="comment">
          <button
            mat-stroked-button
            [cdkCopyToClipboard]="generateEmbedCode(meeting)"
            (click)="handleCopyEmbedCodeClicked()"
          >
            {{ 'MEETING_SCHEDULER.MEETING_LIST.COPY_CODE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
